export default {
  componentName: 'ServicesPage',
  fr: {
    title:
      'Prise de rendez-vous à l’aide du répertoire des services offerts ordonnés dans des catégories.',
    subtitle: 'liste des services',
    subtitleCategories: 'liste des catégories',
    allServices: 'Tous les services',
    home: 'Accueil',
    back: 'Retour',
    meta: "Il est possible d'avoir accès à l'ensemble des services offerts sur la plateforme de prise de rendez-vous Clic Santé...",
    description:
      'Le registre des services donne accès à la liste complète des différents services offerts sur la plateforme Clic Santé. Il est plus simple de trouver le service que vous cherchez en partant de la page d’accueil. Il suffit de sélectionner une catégorie ou d’écrire dans la barre de recherche votre besoin.'
  },
  en: {
    title: 'Make an appointment using the directory of services offered sorted into categories.',
    subtitle: 'list of services',
    subtitleCategories: 'list of categories',
    allServices: 'All the services',
    home: 'Home',
    back: 'Back',
    meta: 'You can access all the services offered on the Clic Sante platform...',
    description:
      "The services register contains the full list of services offered on the Clic Santé platform. It's easier to find what you're looking for from the home page. Select a category or enter your needs in the search bar."
  }
}
